:host {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
  min-height: 55px;
  margin: 0px 20px 0px 4px;
  @media (min-width: 980px) {
    min-height: 47px;
  }
}

span.facets-label {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}
